module.exports = "<app-scheduler></app-scheduler>"